import { render, staticRenderFns } from "./SupportTicketDialogEndedOn.vue?vue&type=template&id=614a84a3"
import script from "./SupportTicketDialogEndedOn.vue?vue&type=script&lang=js"
export * from "./SupportTicketDialogEndedOn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports